import { clsx } from 'clsx';

export const InputLabel = ({
  title,
  isActive,
}: {
  title: string | undefined;
  isActive: boolean;
}) => {
  return (
    <span
      className={clsx(
        'real-estate-input-label absolute whitespace-nowrap truncate text-xs top-3 text-black/40',
        {
          'real-estate-input-label_active': isActive,
          'real-estate-input-label_inactive': !isActive,
        }
      )}
    >
      {title}
    </span>
  );
};
